
import './App.css';
import React from 'react';
import Home_main from './Pages/Home/Home_main.jsx';
import {Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Home_main/>}/>
      </Routes>
    </div>
  );
}

export default App;
